import { createApp } from 'vue'
import { createPinia } from 'pinia'
import rollbar from '@/rollbar.js'
import plugins from '@/plugins'

import Buefy from 'buefy'

import App from './LoginApp.vue'
import gtag from '@/gtag.js'
import router from './router.js'

import '@/assets/base.scss'
import '@/assets/lifficons.css'

const customIconConfig = {
  customIconPacks: {
    liffapp: {
      sizes: {
        default: 'is-size-5',
        'is-small': '',
        'is-medium': 'is-size-3',
        'is-large': 'is-size-1',
      },
      iconPrefix: 'icon-',
      internalIcons: {
        key: 'key-1',
        jewelry: 'jewelry-2',
        creditcard: 'credit-card',
        idcard: 'id-card-1',
        wallet: 'wallet-1',
        other: 'miscellaneous',
      },
    },
  },
}

const pinia = createPinia()
const app = createApp(App).use(Buefy, {
  ...customIconConfig,
})

app.use(pinia)
app.use(router)
app.use(plugins)

gtag.setup(app, router, 'login')

app.config.errorHandler = (err, /* vm, info */) => {
  rollbar.error(err)
  throw err // rethrow for visibility in dev
}
app.config.globalProperties.$rollbar = rollbar

app.mount('#app')
